import LeftNavigationModule from './LeftNavigationModule.component';

export default LeftNavigationModule;